import Form from 'components/Form';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';
import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';

interface Props extends IFormRegister, IFormValues, IFormWatch {
  disabled?: boolean;
  setValue: any;
  activityPlan?: any;
  nurseName: string;
}

export default function ActivityDetail(props: Props) {
  const {
    disabled,
    register,
    watch,
    setValue,
    getValues,
    nurseName,
    activityPlan,
  } = props;

  const contents = [
    {
      label: '교과목명',
      element: (
        <Form.MuiTextField
          {...register('sp_subject_name')}
          required={false}
          disabled={disabled}
          onPaste={e => e.preventDefault()}
          onKeyDown={e => {
            if ((e.ctrlKey || e.metaKey) && e.key === 'v') {
              e.preventDefault();
            }
          }}
          onContextMenu={e => e.preventDefault()}
        />
      ),
    },
    {
      label: '실습날짜',
      element: (
        <Form.MuiTextField
          type="date"
          required={false}
          disabled={disabled}
          {...register('sp_practice_date')}
          onPaste={e => e.preventDefault()}
          onKeyDown={e => {
            if ((e.ctrlKey || e.metaKey) && e.key === 'v') {
              e.preventDefault();
            }
          }}
          onContextMenu={e => e.preventDefault()}
        />
      ),
    },

    {
      label: '시나리오',
      element: (
        <Form.MuiTextField
          {...register('sp_scenario')}
          required={false}
          disabled={disabled}
          onPaste={e => e.preventDefault()}
          onKeyDown={e => {
            if ((e.ctrlKey || e.metaKey) && e.key === 'v') {
              e.preventDefault();
            }
          }}
          onContextMenu={e => e.preventDefault()}
        />
      ),
    },
    {
      label: '담당교수',
      element: (
        <Form.MuiTextField
          {...register('sp_professor')}
          required={false}
          disabled={disabled}
          onPaste={e => e.preventDefault()}
          onKeyDown={e => {
            if ((e.ctrlKey || e.metaKey) && e.key === 'v') {
              e.preventDefault();
            }
          }}
          onContextMenu={e => e.preventDefault()}
        />
      ),
    },
    {
      label: '실습조',
      element: (
        <Form.MuiTextField
          {...register('sp_practice_group')}
          required={false}
          disabled={disabled}
          onPaste={e => e.preventDefault()}
          onKeyDown={e => {
            if ((e.ctrlKey || e.metaKey) && e.key === 'v') {
              e.preventDefault();
            }
          }}
          onContextMenu={e => e.preventDefault()}
        />
      ),
    },
    {
      label: '팀이름',
      element: (
        <Form.MuiTextField
          {...register('sp_team_name')}
          required={false}
          disabled={disabled}
          onPaste={e => e.preventDefault()}
          onKeyDown={e => {
            if ((e.ctrlKey || e.metaKey) && e.key === 'v') {
              e.preventDefault();
            }
          }}
          onContextMenu={e => e.preventDefault()}
        />
      ),
    },
    {
      label: '간호사 1',
      element: (
        <Form.MuiTextField
          {...register('sp_nurse1')}
          required={false}
          disabled={disabled}
          onPaste={e => e.preventDefault()}
          onKeyDown={e => {
            if ((e.ctrlKey || e.metaKey) && e.key === 'v') {
              e.preventDefault();
            }
          }}
          onContextMenu={e => e.preventDefault()}
        />
      ),
    },
    {
      label: '간호사 2',
      element: (
        <Form.MuiTextField
          {...register('sp_nurse2')}
          required={false}
          disabled={disabled}
          onPaste={e => e.preventDefault()}
          onKeyDown={e => {
            if ((e.ctrlKey || e.metaKey) && e.key === 'v') {
              e.preventDefault();
            }
          }}
          onContextMenu={e => e.preventDefault()}
        />
      ),
    },
    {
      label: '간호사 3',
      element: (
        <Form.MuiTextField
          {...register('sp_nurse3')}
          required={false}
          disabled={disabled}
          onPaste={e => e.preventDefault()}
          onKeyDown={e => {
            if ((e.ctrlKey || e.metaKey) && e.key === 'v') {
              e.preventDefault();
            }
          }}
          onContextMenu={e => e.preventDefault()}
        />
      ),
    },
    {
      label: '기록 간호사',
      element: (
        <Form.MuiTextField
          value={nurseName}
          InputProps={{
            readOnly: disabled,
          }}
          onPaste={e => e.preventDefault()}
          onKeyDown={e => {
            if ((e.ctrlKey || e.metaKey) && e.key === 'v') {
              e.preventDefault();
            }
          }}
          onContextMenu={e => e.preventDefault()}
        />
      ),
    },
  ];
  return (
    <RowContainer xs={12}>
      {contents.map(({ label, element }) => (
        <>
          <RowContent
            title={label}
            titleRatio={1}
            childrenRatio={label.includes('간호') ? 2 : 5}
          >
            {element}
          </RowContent>
        </>
      ))}
    </RowContainer>
  );
}
